<template>
    <div class="lang">
        <div v-if="showBtn">
            <van-button @click="ZH()" type="primary" size="mini" :plain="active != 'zhCH'">中文</van-button>
            <van-button @click="EN()" type="primary" size="mini" :plain="active != 'en'">EN </van-button>
        </div>
        <van-action-sheet v-model="show" :actions="actions" @select="onSelect" />
    </div>
</template>
<script>
import { Button, ActionSheet } from 'vant';
export default {
    name:"Language",
    components:{
        [Button.name]:Button,
        [ActionSheet.name]:ActionSheet
    },
    props: {
        showBtn: {
            type: Boolean,
            default: true
        },
        showSelect: {
            type: Boolean,
            default: false
        }
    },
    data(){
        return{
            active: localStorage.getItem('lang') || 'zhCH',
            actions: [{name: '中文'}, {name: 'English'}],
            show: false,
        }
    },
    methods:{
        EN(){
            this.active = 'en';
            this.setLocal();
        },
        ZH(){
            this.active = 'zhCH';
            this.setLocal();
        },
        setLocal(){
            this.$i18n.locale = this.active;
            this.$Local(this.active);
            localStorage.setItem('lang', this.active);
        },
        onSelect({name}){
            if (name == '中文'){
                this.ZH();
            } else {
                this.EN();
            }
            this.show = false;
            this.$emit('select', this.active);
        }
    },
    watch: {
        showSelect(){
            if (this.showSelect){
                this.show = true
            }
        }
    },
    created() {
        this.setLocal();
    }
}
</script>
<style lang="less" scoped>
.lang{
    position: fixed;
    right:30px;
    top:15px;
    z-index:1;
    height:50px;
    width:100px;
    display: flex;
    justify-content: center;
    align-items: center;
    button{
        margin: 0;
        width: 40px;
    }
}
</style>
